const settings_initial: SettingsType = {
  locale: 'pt_br',
};

export default settings_initial;
